import { ModalIOF } from '@old/ui/modal/modal';
import { configButtonStylesContained, configButtonStylesOutlined } from '@old/styles/generic-styles';
import i18n from '../../libs/language';
import { Stack, TextField, Button, CircularProgress, Box } from '@mui/material';
import { postSendObservations } from '@old/services/domain/page/inconsistencies/post-send-observations';
import { useService } from '@old/hooks/use-service';
import { useState } from 'react';
import { useGlobalStore } from '@old/global-store/use-store';

type ObservationModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  itemId: number;
  setSuccessToast: (data: boolean) => void;
};

export const InconsistenciesObservationModal = ({
  open,
  setOpen,
  itemId,
  setSuccessToast,
}: ObservationModalProps) => {
  const { email } = useGlobalStore();
  const { trigger, isLoading } = useService(postSendObservations, {
    onSuccess: () => {
      setOpen(false);
      setSuccessToast(true);
    },
  });
  const [observations, setObservations] = useState('');
  return (
    <Box>
      <ModalIOF open={open} ModalIsOpen={setOpen}>
        <ModalIOF.Header>
          <ModalIOF.Title>{i18n.t('app.inconsistencies_page.detected_inconsistencies')}</ModalIOF.Title>
        </ModalIOF.Header>
        <ModalIOF.Body>
          <Stack direction={'column'} justifyContent={'center'} alignItems={'center'} marginTop={-2}>
            <p style={{ textAlign: 'left' }}>{i18n.t('app.inconsistencies_page.text_modal')}</p>
            <TextField
              size="medium"
              sx={{ width: '95%' }}
              multiline
              placeholder={i18n.t('app.observations')}
              rows={4}
              onChange={(e) => setObservations(e.target.value)}
            />
          </Stack>
          <Stack direction="row" spacing={2} justifyContent={'flex-end'} marginTop={3}>
            <Button
              variant="outlined"
              size="medium"
              sx={configButtonStylesOutlined}
              onClick={() => setOpen(false)}
            >
              {i18n.t('app.close')}
            </Button>
            <Button
              variant="contained"
              size="medium"
              sx={configButtonStylesContained}
              disabled={observations.length === 0}
              onClick={() =>
                trigger({
                  body: { discrepancyResultId: itemId, userComments: observations, userEmail: email ?? '' },
                })
              }
            >
              {isLoading ? <CircularProgress size={24} /> : 'Enviar'}
            </Button>
          </Stack>
        </ModalIOF.Body>
      </ModalIOF>
    </Box>
  );
};
